import React from "react";
import AuthExperience from "../experience/AuthExperience";
import AuthEntryGate from "../identity/AuthEntryGate";
import { beginIdentityRegistration, getAuthSwitchPath } from "../identity/identityClient";

export default function Register() {
  return (
    <AuthEntryGate>
      <AuthExperience
        onContinue={beginIdentityRegistration}
        mode="signup"
        productName="Clikkle Store"
        productHomeUrl="https://clikkle.com"
        productBrandPath="/images/clikkle/brand/logos/store-logo.png"
        loginPath={getAuthSwitchPath("login")}
      />
    </AuthEntryGate>
  );
}
